import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
});

export const pharmacyRegistrationSchema = z.object({
  legalName: z.string().min(1),
  email: z.string().email(),
  npi: z.string().min(8),
  stateLicense: z.string().min(4),
});

export const onboardingSchema = z.object({
  pharmacyId: z.string().min(1),
  acceptedTerms: z.literal(true),
  paymentMethodId: z.string().min(1),
  shippingAddressId: z.string().min(1),
});
